import { querySnapshotToArray, firestoreDocument } from '@/services/utils/Utils.js';

import { saveRecord } from '@/services/firebase/FirestoreService.js';

import firebase from 'firebase';

export const namespaced = true;

export const state = {
  trainingVideos: [],
  subscription: null,
};

export const getters = {
  trainingVideos: ({ trainingVideos }) => trainingVideos,
  trainingVideo: (state) => (id) => state.trainingVideos.find((trainingVideo) => trainingVideo.id === id),
};

export const mutations = {
  SET_TRAINING_VIDEOS(state, trainingVideos) {
    state.trainingVideos = trainingVideos;
  },
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
};

export const actions = {
  fetchTrainingVideos({ state, commit }) {
    if (state.subscription) {
      return;
    }

    const collection = firebase.firestore().collection('trainingVideos');
    const subscription = collection.onSnapshot((querySnapshot) => {
      commit('SET_TRAINING_VIDEOS', querySnapshotToArray(querySnapshot));
    });

    commit('SET_SUBSCRIPTION', subscription);
  },
  saveTrainingVideo(context, trainingVideoOptions) {
    return saveRecord(trainingVideoOptions).then((id) => id);
  },
  fetchTrainingVideo({ getters }, id) {
    return new Promise((resolve, reject) => {
      if (getters.trainingVideo(id)) {
        resolve(getters.trainingVideo(id));
        return;
      }

      const trainingVideoDocument = firestoreDocument('trainingVideos')(id);
      trainingVideoDocument
        .get()
        .then((querySnapshot) => {
          resolve({
            ...querySnapshot.data(),
            id: querySnapshot.id,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
